import { ComponentsSection } from './ComponentsSection';
import { useComponentIDs } from './componentUtils';

export const ComponentsSections = () => {
  const componentIDs = useComponentIDs();

  return (
    <>
      {componentIDs.map((stackComponentID) => (
        <ComponentsSection key={stackComponentID} stackComponentID={stackComponentID} />
      ))}
    </>
  );
};
